import React, { useState, Fragment } from 'react';
import { createPortal } from 'react-dom';
import { isOnMac } from '../../utilities/browserUtility';

const HELP_ARTICLES = [
    {
        title: 'Editor overview',
        url: 'https://support.tettra.com/article/331-page-editor-overview',
    },
    {
        title: 'Importing pages',
        url: 'https://support.tettra.com/article/93-how-to-import-pages-into-tettra',
    },
    {
        title: 'Internal page linking',
        url: 'https://support.tettra.com/article/125-how-to-reference-or-link-one-tettra-page-in-another',
    },
    {
        title: 'Mentioning a teammate',
        url: 'https://support.tettra.com/article/141-mention-a-teammate-in-a-page',
    },
];

const ALL_ARTICLE_LINK = 'https://support.tettra.com';

const HelpArticles = () => (
    <div>
        <h2>Getting started</h2>
        <ul className="mb0">
            {
                HELP_ARTICLES.map((article) => (
                    <li>
                        <a href={article.url} target="_blank" key={article.url} rel="noreferrer">{article.title}</a>
                    </li>
                ))
            }
        </ul>
        <a href={ALL_ARTICLE_LINK} target="_blank" rel="noreferrer">...view all</a>
    </div>
);

const MacShortcuts = () => (
    <table>
        <tbody>
            <tr>
                <td><b>Bold</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">b</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Italic</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">i</span>
                </td>
            </tr>
            <tr>
                <td><b>Underline</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">u</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Highlight</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">e</span>
                </td>
            </tr>
            <tr>
                <td><b>Header 1</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">⌥</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">1</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Strikethrough</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">shift</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">x</span>
                </td>
            </tr>
            <tr>
                <td><b>Header 2</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">⌥</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">2</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Insert link</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">k</span>
                </td>
            </tr>
            <tr>
                <td><b>Header 3</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">⌥</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">3</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Undo</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">z</span>
                </td>
            </tr>
            <tr>
                <td><b>Ordered List</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">shift</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">7</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Redo</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">shift</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">z</span>
                </td>
            </tr>
            <tr>
                <td><b>Unordered List</b></td>
                <td>
                    <span className="keyboard_key">⌘</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">shift</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">8</span>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
        </tbody>
    </table>
);

const WinShortcuts = () => (
    <table>
        <tbody>
            <tr>
                <td><b>Bold</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">b</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Italic</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">i</span>
                </td>
            </tr>
            <tr>
                <td><b>Underline</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">u</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Highlight</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">e</span>
                </td>
            </tr>
            <tr>
                <td><b>Header 1</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">alt</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">1</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Strikethrough</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">shift</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">x</span>
                </td>
            </tr>
            <tr>
                <td><b>Header 2</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">alt</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">2</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Insert link</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">k</span>
                </td>
            </tr>
            <tr>
                <td><b>Header 3</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">alt</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">3</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Undo</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">z</span>
                </td>
            </tr>
            <tr>
                <td><b>Ordered List</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">shift</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">7</span>
                </td>
                <td>&nbsp;</td>
                <td><b>Redo</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">shift</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">z</span>
                </td>
            </tr>
            <tr>
                <td><b>Unordered List</b></td>
                <td>
                    <span className="keyboard_key">ctrl</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">shift</span>
                    {' '}
+
                    {' '}
                    <span className="keyboard_key">8</span>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
        </tbody>
    </table>
);

class KeyboardShortcuts extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isOnMac: isOnMac() };
    }

    render() {
        const { isOnMac } = this.state;
        const macButtonClass = isOnMac ? 'active mr2' : 'mr2';
        const winButtonClass = isOnMac ? '' : 'active';
        return (
            <div>
                <h2>Keyboard shortcuts</h2>
                <div className="platform-buttons">
                    <span className={macButtonClass} onMouseDown={() => this.setState({ isOnMac: true })}>Mac</span>
                    <span className={winButtonClass} onMouseDown={() => this.setState({ isOnMac: false })}>Windows/Linux</span>
                </div>
                { isOnMac ? <MacShortcuts /> : <WinShortcuts /> }
            </div>
        );
    }
}

const InsertingReferences = () => (
    <div>
        <h2>Inserting mentions + references</h2>
        <table>
            <tbody>
                <tr>
                    <td><b>Mention Teammate</b></td>
                    <td>
                        <span className="keyboard_key">@</span>
Teammate name
                    </td>
                    <td>&nbsp;</td>
                    <td><b>Reference Tettra page</b></td>
                    <td>
                        <span className="keyboard_key">+</span>
Page title
                    </td>
                </tr>
                <tr>
                    <td><b>Reference GitHub issue</b></td>
                    <td>
                        <span className="keyboard_key">#</span>
title/issue number
                    </td>
                    <td>&nbsp;</td>
                    <td><b>Reference Google Drive file</b></td>
                    <td>
                        <span className="keyboard_key">#</span>
File title
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
);

const Automarkdown = () => (
    <div>
        <h2>Automarkdown</h2>
        <table>
            <tbody>
                <tr>
                    <td><b>Bold</b></td>
                    <td>
                        <span className="keyboard_key">**</span>
                        <span>bold text</span>
                        <span className="keyboard_key">**</span>
                    </td>
                    <td>&nbsp;</td>
                    <td><b>Italic</b></td>
                    <td>
                        <span className="keyboard_key">*</span>
                        <span>italic text</span>
                        <span className="keyboard_key">*</span>
                    </td>
                </tr>
                <tr>
                    <td><b>Highlight</b></td>
                    <td>
                        <span className="keyboard_key">==</span>
                        <span>highlighted text</span>
                        <span className="keyboard_key">==</span>
                    </td>
                    <td>&nbsp;</td>
                    <td><b>Strikethrough</b></td>
                    <td>
                        <span className="keyboard_key">~~</span>
                        <span>strikethrough text</span>
                        <span className="keyboard_key">~~</span>
                    </td>
                </tr>
                <tr>
                    <td><b>Header one</b></td>
                    <td>
                        <span className="keyboard_key">#</span>
                        {' '}
+
                        {' '}
                        <span className="keyboard_key">space</span>
                    </td>
                    <td>&nbsp;</td>
                    <td><b>Code block</b></td>
                    <td>
                        <span className="keyboard_key">```</span>
                        {' '}
+
                        {' '}
                        <span className="keyboard_key">space</span>
                    </td>
                </tr>
                <tr>
                    <td><b>Header two</b></td>
                    <td>
                        <span className="keyboard_key">##</span>
                        {' '}
+
                        {' '}
                        <span className="keyboard_key">space</span>
                    </td>
                    <td>&nbsp;</td>
                    <td><b>Ordered list</b></td>
                    <td>
                        <span className="keyboard_key">1.</span>
                        {' '}
+
                        {' '}
                        <span className="keyboard_key">space</span>
                    </td>
                </tr>
                <tr>

                    <td><b>Header three</b></td>
                    <td>
                        <span className="keyboard_key">###</span>
                        {' '}
+
                        {' '}
                        <span className="keyboard_key">space</span>
                    </td>
                    <td>&nbsp;</td>
                    <td><b>Unordered list</b></td>
                    <td>
                        <span className="keyboard_key">-</span>
                        {' '}
+
                        {' '}
                        <span className="keyboard_key">space</span>
                    </td>
                </tr>
                <tr>
                    <td><b>Inline code</b></td>
                    <td>
                        <span className="keyboard_key">`</span>
                        <span>inline code</span>
                        <span className="keyboard_key">`</span>
                    </td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                </tr>
            </tbody>
        </table>
    </div>
);

const EditorHelpModal = (props) => {
    const onClick = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return props.closeModal();
        }
    };

    return (
        <div className="react-modal open fullscreen" onMouseDown={onClick}>
            <div className="modal-content editor-help-modal">
                <h2>Editor</h2>
                <HelpArticles />
                <KeyboardShortcuts />
                <InsertingReferences />
                <Automarkdown />
            </div>
        </div>
    );
};

const EditorHelpModalWrapper = ({ text }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Fragment>
            <span className="dropdown-option link" onClick={() => setShowModal(true)}>{text}</span>
            { showModal && createPortal(<EditorHelpModal closeModal={() => setShowModal(false)} />, document.body) }
        </Fragment>

    );
};

export default EditorHelpModalWrapper;
